import { render, staticRenderFns } from "./CompanyFacts.vue?vue&type=template&id=39bd47e8&"
import script from "./CompanyFacts.vue?vue&type=script&lang=js&"
export * from "./CompanyFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports